<template>
  <FormLayout
    :title="`Registration Success`"
  >
    <!-- 图标 -->
    <div class="icon">
      <img src="@/assets/index/header/register-success.png" alt="">
    </div>
    <h4 class="message">Registration Success</h4>
    <Button @click="deno">Complete</Button>
  </FormLayout>
</template>

<script>
import Button from '@/components/Button';
import FormLayout from '../FormLayout';

export default {
  components: {
    FormLayout,
    Button,
  },
  methods: {
    deno() {
      this.$parent.$parent.$parent.close();
    }
  },
}
</script>

<style lang="less" scoped>
  .icon {
    width: 61px;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  .message {
    margin-top: 14px;
    margin-bottom: 61px;
    font-size: 22px;
    color: #343434;
    text-align: center;
    font-weight: normal;
  }
</style>
